// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_2q-1";
export var movingGradient = "_2q-4";
export var movingGradientBlock = "_2q-2";
export var skeleton = "_2q-0";
export var skeletonText = "_2q-3";